var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.selectRandom([ "The protocol is registered at: ", "The protocol is available via: ", ]) + _vm.$tera.project.introprotocol)+" ")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$tera.project.intro)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }